import React from 'react';

/**
 * Reusable skeleton loader for client pages with list items
 */
export const ListItemSkeleton = ({ count = 3 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="border border-gray-200 rounded-lg p-4 sm:p-6 animate-pulse"
        >
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-gray-200 rounded-lg flex-shrink-0">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>
            <div className="flex-1 space-y-3">
              <div className="h-5 bg-gray-200 rounded w-3/4">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
              <div className="h-4 bg-gray-200 rounded w-full">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
              <div className="h-4 bg-gray-200 rounded w-2/3">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

/**
 * Skeleton for card grid layout
 */
export const CardGridSkeleton = ({ count = 4 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="border border-gray-200 rounded-lg p-4 animate-pulse"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center space-x-3 flex-1">
              <div className="w-12 h-12 bg-gray-200 rounded-lg flex-shrink-0">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-gray-200 rounded w-3/4">
                  <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                </div>
                <div className="h-3 bg-gray-200 rounded w-1/2">
                  <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                </div>
              </div>
            </div>
            <div className="w-5 h-5 bg-gray-200 rounded">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>
          </div>
          <div className="space-y-2 mb-4">
            <div className="h-3 bg-gray-200 rounded w-2/3">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>
            <div className="h-3 bg-gray-200 rounded w-3/4">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>
            <div className="h-4 bg-gray-200 rounded w-1/3">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>
          </div>
          <div className="flex space-x-2">
            <div className="flex-1 h-9 bg-gray-200 rounded-lg">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>
            <div className="flex-1 h-9 bg-gray-200 rounded-lg">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

/**
 * Skeleton for notification items
 */
export const NotificationSkeleton = ({ count = 5 }) => {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="border rounded-lg p-4 animate-pulse"
        >
          <div className="flex items-start space-x-3">
            <div className="w-5 h-5 bg-gray-200 rounded flex-shrink-0">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-1/3">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
              <div className="h-3 bg-gray-200 rounded w-full">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
              <div className="h-3 bg-gray-200 rounded w-1/4">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

/**
 * Skeleton for transaction items
 */
export const TransactionSkeleton = ({ count = 5 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="border border-gray-200 rounded-lg p-4 sm:p-6 animate-pulse"
        >
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div className="flex items-start space-x-4 flex-1">
              <div className="w-10 h-10 bg-gray-200 rounded-lg flex-shrink-0">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
              <div className="flex-1 space-y-2">
                <div className="flex items-center space-x-2">
                  <div className="h-4 bg-gray-200 rounded w-24">
                    <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                  </div>
                  <div className="h-4 bg-gray-200 rounded w-20">
                    <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                  </div>
                </div>
                <div className="h-3 bg-gray-200 rounded w-full">
                  <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                </div>
                <div className="flex items-center space-x-4">
                  <div className="h-3 bg-gray-200 rounded w-32">
                    <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                  </div>
                  <div className="h-3 bg-gray-200 rounded w-24">
                    <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="h-6 bg-gray-200 rounded w-20">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
              <div className="w-5 h-5 bg-gray-200 rounded">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

/**
 * Skeleton for form fields
 */
export const FormSkeleton = ({ fields = 4 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: fields }).map((_, index) => (
        <div key={index} className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-24">
            <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
          </div>
          <div className="h-10 bg-gray-200 rounded-lg">
            <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
          </div>
        </div>
      ))}
      <div className="h-10 bg-gray-200 rounded-lg w-32">
        <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
      </div>
    </div>
  );
};

/**
 * Skeleton for How It Works page (hero, steps, features, CTA)
 */
export const HowItWorksSkeleton = () => {
  const SkeletonBar = ({ className = '' }) => (
    <div className={`h-4 bg-gray-200 rounded ${className}`} />
  );
  return (
    <div className="min-h-screen bg-white animate-pulse">
      {/* Hero Skeleton */}
      <div className="bg-gradient-to-br from-gray-50 to-white border-b border-gray-100">
        <div className="page-container py-8 sm:py-12 md:py-20 px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center space-y-4">
            <div className="inline-block h-8 w-40 bg-gray-200 rounded-full mx-auto" />
            <div className="h-12 sm:h-14 md:h-16 bg-gray-200 rounded-lg max-w-xl mx-auto" />
            <div className="space-y-2 max-w-2xl mx-auto">
              <SkeletonBar className="w-full" />
              <SkeletonBar className="w-5/6 mx-auto" />
              <SkeletonBar className="w-4/5 mx-auto" />
            </div>
            <div className="flex justify-center gap-4 pt-4">
              <div className="h-11 w-32 bg-gray-200 rounded-xl" />
              <div className="h-11 w-32 bg-gray-200 rounded-xl" />
            </div>
          </div>
        </div>
      </div>

      {/* Steps Skeleton */}
      <div className="py-8 sm:py-12 md:py-20 bg-white">
        <div className="page-container px-4 sm:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8 lg:gap-12">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="border border-gray-200 rounded-xl p-4 sm:p-6 md:p-8">
                  <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-xl bg-gray-200 flex-shrink-0" />
                    <div className="flex-1 w-full space-y-2">
                      <div className="h-6 bg-gray-200 rounded w-3/4" />
                      <div className="h-4 bg-gray-200 rounded w-full" />
                      <div className="h-4 bg-gray-200 rounded w-5/6" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Features Skeleton */}
      <div className="py-8 sm:py-12 md:py-20 bg-gray-50">
        <div className="page-container px-4 sm:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-8 sm:mb-12 md:mb-16 space-y-3">
              <div className="h-8 bg-gray-200 rounded-lg max-w-md mx-auto" />
              <div className="h-4 bg-gray-200 rounded max-w-xl mx-auto" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="bg-white rounded-xl p-4 sm:p-6 border border-gray-200">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-200 rounded-xl mb-3 sm:mb-4" />
                  <div className="h-5 bg-gray-200 rounded w-2/3 mb-2" />
                  <div className="space-y-2">
                    <div className="h-4 bg-gray-200 rounded w-full" />
                    <div className="h-4 bg-gray-200 rounded w-4/5" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* CTA Skeleton */}
      <div className="py-8 sm:py-12 md:py-20 bg-gray-900">
        <div className="page-container px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center space-y-4">
            <div className="h-10 bg-gray-700 rounded-lg max-w-lg mx-auto" />
            <div className="h-4 bg-gray-600 rounded max-w-xl mx-auto" />
            <div className="flex justify-center gap-4 pt-4">
              <div className="h-11 w-36 bg-gray-600 rounded-xl" />
              <div className="h-11 w-32 bg-gray-600 rounded-xl" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Skeleton for Safety page (hero, tabs, content cards, emergency)
 */
export const SafetySkeleton = () => {
  return (
    <div className="min-h-screen bg-gray-50 -mt-16 animate-pulse">
      {/* Hero Skeleton */}
      <div className="bg-gradient-to-br from-black to-gray-900 pt-16 pb-12 sm:pt-20 sm:pb-16">
        <div className="page-container px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center space-y-4">
            <div className="inline-block w-12 h-12 sm:w-16 sm:h-16 bg-white/10 rounded-full mx-auto" />
            <div className="h-8 sm:h-10 md:h-12 bg-white/20 rounded-lg max-w-md mx-auto" />
            <div className="h-4 sm:h-5 bg-white/15 rounded max-w-xl mx-auto" />
            <div className="h-4 sm:h-5 bg-white/15 rounded max-w-lg mx-auto" />
          </div>
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="page-container py-8 sm:py-12 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Tabs + Content Card Skeleton */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6 sm:mb-8">
            <div className="border-b border-gray-200 px-4 py-3">
              <div className="flex gap-6">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="h-4 w-24 bg-gray-200 rounded" />
                ))}
              </div>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="border border-gray-200 rounded-lg p-4">
                    <div className="flex items-start gap-3 mb-3">
                      <div className="w-10 h-10 bg-gray-200 rounded-lg flex-shrink-0" />
                      <div className="h-5 bg-gray-200 rounded w-3/4" />
                    </div>
                    <div className="space-y-2">
                      <div className="h-4 bg-gray-200 rounded w-full" />
                      <div className="h-4 bg-gray-200 rounded w-5/6" />
                      <div className="h-4 bg-gray-200 rounded w-4/5" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Emergency Section Skeleton */}
          <div className="bg-red-50/50 border border-red-200 rounded-xl p-4 sm:p-6">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-red-200 rounded flex-shrink-0" />
              <div className="flex-1 space-y-3">
                <div className="h-5 bg-red-200/50 rounded w-48" />
                <div className="space-y-2">
                  <div className="h-4 bg-red-200/50 rounded w-full" />
                  <div className="h-4 bg-red-200/50 rounded w-3/4" />
                </div>
                <div className="flex gap-3 pt-2">
                  <div className="h-9 w-40 bg-red-200/50 rounded-lg" />
                  <div className="h-9 w-32 bg-red-200/50 rounded-lg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Skeleton for FAQ items (question + answer layout)
 */
export const FAQSkeleton = ({ count = 6 }) => {
  return (
    <div className="space-y-3 sm:space-y-4">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="border border-gray-200 rounded-lg p-3 sm:p-4 md:p-6 animate-pulse"
        >
          <div className="space-y-2 sm:space-y-3">
            <div className="h-4 sm:h-5 bg-gray-200 rounded w-3/4 max-w-md">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite] rounded" />
            </div>
            <div className="space-y-2">
              <div className="h-3 sm:h-4 bg-gray-200 rounded w-full">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite] rounded" />
              </div>
              <div className="h-3 sm:h-4 bg-gray-200 rounded w-5/6">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite] rounded" />
              </div>
              <div className="h-3 sm:h-4 bg-gray-200 rounded w-4/5 max-w-md">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite] rounded" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

